var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryCollege = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/college") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/college"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 7.000000)",
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.397184,16.9216514 C20.6777669,17.0331193 20.9583497,17.0331193 21.2389326,16.9216514 L36.5868146,11.208922 L36.5868146,24.39 C36.9796306,24.3063991 37.3724466,24.2227982 37.7933209,24.2227982 C38.2141952,24.2227982 38.6070112,24.2785321 38.9998272,24.39 L38.9998272,10.2893119 L40.7113826,9.67623853 C41.7495391,9.28610092 41.7495391,7.80915138 40.7113826,7.41901376 L21.2108743,0.173600917 C20.9302914,0.0621330275 20.6216503,0.0621330275 20.3691257,0.173600917 L0.868617418,7.41901376 C-0.169539139,7.80915138 -0.169539139,9.28610092 0.868617418,9.67623853 L20.397184,16.9216514 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9037157,27.09 C35.8466775,27.09 34.29,29.7509827 34.29,33.2703468 L34.29,35.7596532 C34.29,36.4463584 34.8181584,36.99 35.4853059,36.99 L40.2943276,36.99 C40.9614751,36.99 41.4896335,36.4463584 41.4896335,35.7596532 L41.4896335,33.2703468 C41.5174313,29.7509827 39.9607538,27.09 37.9037157,27.09 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4953108,15.39 L22.0858442,19.4787091 C21.2343914,19.7765621 20.3261752,19.7765621 19.5031042,19.4787091 L8.09363757,15.39 C7.07189429,18.9642357 7.32733011,21.319982 7.29894835,22.0510757 C7.29894835,22.8904796 8.17878285,23.459108 8.97347206,23.1341775 C9.00185382,23.1341775 11.8684114,22.0510757 14.6498236,22.0510757 C17.2325636,22.0510757 19.9855941,24.108969 20.0139758,24.1360466 C20.4397022,24.4609771 21.0924826,24.4880546 21.5465908,24.1360466 C22.3128982,23.5674182 24.7537294,22.0510757 26.910743,22.0510757 C29.6921552,22.0510757 32.5587128,23.1341775 32.5870945,23.1341775 C33.3817838,23.4320304 34.2616182,22.863402 34.2616182,22.0510757 C34.2616182,21.3470596 34.5170541,18.9642357 33.4953108,15.39 L33.4953108,15.39 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryCollege);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-college.f7026bb671867c723a9577cdb1eb289e.svg";